import { createAsyncThunk, createSlice, isFulfilled } from "@reduxjs/toolkit";
import { updateUserWalletAddress } from "services/apiService";
import { getUserTokenBalance } from "services/contractService";
import RewardService from "services/rewardService";
import Web3 from "web3";

const WALLET_CONNECTED_ITEM = "@Mealswap/walletProviderConnected";

// const networks = {
//   //testnet
//   bsc: {
//     chainId: `0x${Number(97).toString(16)}`,
//     chainName: "Binance Smart Chain Testnet",
//     nativeCurrency: {
//       name: "Binance Chain Native Token",
//       symbol: "tBNB",
//       decimals: 18,
//     },
//     rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
//     blockExplorerUrls: ["https://testnet.bscscan.com/"],
//   },
// };

const networks = {
  //mainnet
  bsc: {
    chainId: `0x${Number(56).toString(16)}`,
    chainName: "Binance Smart Chain Mainnet",
    nativeCurrency: {
      name: "Binance Chain Native Token",
      symbol: "BNB",
      decimals: 18,
    },
    rpcUrls: ["https://bsc-dataseed.binance.org"],
    blockExplorerUrls: ["https://bscscan.com"],
  },
};

let getWeb3;

export const connectWallet = createAsyncThunk(
  "wallet/connectWallet",
  async (providerAPI, { rejectWithValue }) => {
    try {
      if (window[providerAPI] && window[providerAPI].isMetaMask) {
        localStorage.setItem(WALLET_CONNECTED_ITEM, providerAPI);

        const currentChainId = await window[providerAPI].request({
          method: "eth_chainId",
        });
        // console.log("currentChainId", currentChainId);
        // console.log("test", `0x${Number(97).toString(16)}`);

        // console.log(
        //   "test2",
        //   Web3.utils.hexToNumber(`0x${Number(97).toString(16)}`)
        // );
        const currentChainIdConverted = Web3.utils.hexToNumber(currentChainId);

        // console.log("currentChainIdConverted", currentChainIdConverted);
        if (currentChainIdConverted !== 56) {
          try {
            await window[providerAPI].request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  ...networks.bsc,
                },
              ],
            });
          } catch {
            console.log("chainIDError");
          }
        }
        const [account] = await window[providerAPI].request({
          method: "eth_requestAccounts",
        });
        const getBalance = await getUserTokenBalance(
          new Web3(window[providerAPI]),
          account
        );
        getWeb3 = new Web3(window[providerAPI]);
        const balance = getBalance.tokenBal ? getBalance.tokenBal : 0;
        // console.log("bal", balance);
        const chainId = await window[providerAPI].request({
          method: "eth_chainId",
        });
        const chainIdConverted = Web3.utils.hexToNumber(chainId);

        if (chainIdConverted === 56 || chainIdConverted === 97) {
          // console.log("chainIdConverted", chainIdConverted);
          const updateUserWalletAddressRes = await updateUserWalletAddress({
            walletAddress: account,
          });
        }

        return { chainIdConverted, account, balance };
      } else {
        // console.log("token", localStorage.jwtTokenSingh);
        //const deepLink = `https://metamask.app.link/dapp/new-demo.singhcoin.io/?ut=${localStorage.jwtTokenSingh}&name=${localStorage.userNameSingh}`;
        const deepLink = `https://metamask.app.link/dapp/app.singhcoin.io/?ut=${localStorage.jwtTokenSingh}&name=${localStorage.userNameSingh}`;
        window.location.replace(deepLink);
      }
    } catch (error) {
      console.log("Rejected", error);
      return rejectWithValue(error.message);
    }
  }
);

export const web3Instance = () => {
  return getWeb3;
};

// export const web3 = new Web3(window.ethereum);

const initialState = {
  address: "",
  chainId: 0,
  balance: 0,
  isWeb3Enabled: false,
  isWalletLoading: false,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState: initialState,
  reducers: {
    walletDisconnect(state, action) {
      localStorage.removeItem("@Mealswap/walletProviderConnected");
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(connectWallet.pending, (state) => {
        state.isWalletLoading = true;
      })
      .addCase(connectWallet.fulfilled, (state, action) => {
        state.isWalletLoading = false;
        state.isWeb3Enabled = true;
        // console.log("payload", action.payload);
        state.address = action.payload.account;
        state.chainId = action.payload.chainIdConverted;
        state.balance = action.payload.balance;
      })
      .addCase(connectWallet.rejected, (state, action) => {
        state.isWalletLoading = false;
        state.isWeb3Enabled = false;
      });
  },
});

export const { walletDisconnect } = walletSlice.actions;
export default walletSlice.reducer;
